<template>
  <div :class="type" v-click-outside="onCloseDropdown">
    <div v-if="$slots['dropdow-button']" @click.stop="toggleShow">
      <slot name="dropdow-button"></slot>
    </div>
    <div
      class="dropdown-menu"
      :class="[alignment, isShowClass()]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  props: {
    alignment: {
      type: String,
      default: 'left',
    },
    type: {
      type: String,
      default: 'dropdown',
    },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    onCloseDropdown() {
      this.showMenu = false;
    },
    toggleShow() {
      this.showMenu = !this.showMenu;
    },
    isShowClass() {
      if (this.showMenu) {
        return 'show';
      }
      return '';
    },
  },
};

</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.dropdown-menu {

  &.right {
    left: auto;
    right: 0;
  }
}

.dropdown-item {
  cursor: pointer;
}
</style>
